// extracted by mini-css-extract-plugin
module.exports = {"f18sps10":"f18sps10"};